import { TopMenuEvent } from './top-menu-events.model';

/** Screens this wide have free space by the logo, so the live text loads after the page settles. */
export const LIVE_TEXT_MIN_WIDTH = 1680;

/** How long after a hover-open a click on Marketplace still counts as "open", not "close". */
export const HOVER_CLICK_GRACE_MS = 600;

export interface TopMenuUnderline {
  left: number;
  width: number;
  on: boolean;
}

/** Underline under a nav link, inset by the link's 10px side padding. */
export function underlineFor(link: HTMLElement): TopMenuUnderline {
  return { left: link.offsetLeft + 10, width: Math.max(link.offsetWidth - 20, 0), on: true };
}

export function liveEventOf(events: TopMenuEvent[]): TopMenuEvent | undefined {
  return (events || []).find((event) => event.isLive);
}

/** "Coming up" in the Marketplace panel: live first (the list is already sorted), three rows. */
export function panelEventsOf(events: TopMenuEvent[]): TopMenuEvent[] {
  return (events || []).slice(0, 3);
}

/** "Starting soon" in the search panel: the next two that are not live. */
export function soonEventsOf(events: TopMenuEvent[]): TopMenuEvent[] {
  return (events || []).filter((event) => !event.isLive).slice(0, 2);
}

export function canHover(): boolean {
  return !!window.matchMedia && window.matchMedia('(hover: hover)').matches;
}

/** Runs the callback when the browser is idle (2s later where requestIdleCallback is missing). */
export function whenIdle(callback: () => void): void {
  const idle = (window as any).requestIdleCallback || ((fn: () => void) => setTimeout(fn, 2000));
  idle(callback);
}
